_ = require 'underscore'
ApiPromise = require 'network/api-promise'
Dialog = require 'views/lib/dialog'
React = require 'react'
t = require('views/internal/recup-with-helpers')('billing')
track = require 'debug/track'
Util = require 'lib/util'
zipCodeToState = require './internal/zip-code-to-state'

class TaxExemptionDialogComponent extends React.Component
  displayName: 'TaxExemptionDialogComponent'
  componentDidMount: ->
    @props.initGenCert(@genCertForm)

  render: t.renderable ->
    t.div '.window-main-col', =>
      t.span '.icon-lg.icon-close.dialog-close-button.js-close-window'
      t.span '.avalara-logo'
      t.div '#avalaraGenCertForm',
        ref: (el) => @genCertForm = el

module.exports = class TaxExemptionComponent extends React.Component
  displayName: 'TaxExemptionComponent'

  constructor: ->
    @apiPromise = null
    @state =
      country: ''
      zip: ''
      uploadCertSuccess: false
      genCertFailure: false

  componentDidMount: ->
    @apiPromise = ApiPromise
      url: @props.statementUrl
      dataType: 'json'
      type: 'get'
    .then (data) =>
      if !data.error?
        @setState
          country: data.country
          zip: data.zip

  showGenCertDialog: =>
    Dialog.show
      maxWidth: 550
      displayType: 'avalara-certcapture'
      reactElement: React.createElement TaxExemptionDialogComponent,
        initGenCert: (el) =>
          GenCert.init(document.getElementById('avalaraGenCertForm'), {
            edit_purchaser: true
            onCertSuccess: =>
              @setState
                uploadCertSuccess: true
            onUpload: =>
              @setState
                uploadCertSuccess: true
            onValidateFailure: =>
              Dialog.hide()
              @setState
                genCertFailure: true
            onCertFailure: =>
              Dialog.hide()
              @setState
                genCertFailure: true
          })

    paidAccount = @props.paidAccount
    stateName = zipCodeToState(parseInt(@state.zip, 10)).name
    customer =
      name: paidAccount.contactFullName
      country: 'United States'
      zip: @state.zip
      state: stateName

    GenCert.setCustomerNumber(String(paidAccount.ixSubscriber))
    GenCert.setCustomerData(customer)
    GenCert.setShipZone(stateName)
    GenCert.show()

  onClickTaxExemptionCertificate: =>
    track('Organization View', 'Billing Page', 'Open Submit Tax Exemption Certificate')

    if !window.GenCert?
      Util.loadScript('https://app.certcapture.com/gencert2/js?cid=' + window.avalaraCertcaptureId + '&key=' + window.avalaraCertcaptureKey)
      .then @showGenCertDialog
      .catch =>
        @setState
          genCertFailure: true
    else
      @apiPromise.then(@showGenCertDialog)

  render: t.renderable ->
    { country, zip, uploadCertSuccess, genCertFailure } = @state

    if country == 'US'
      t.div '.window-module', =>
        t.div '.window-module-title', ->
          t.h3 ->
            t.format 'tax-exemption'
        t.div '.u-gutter', =>
          t.p =>
            t.format 'are-you-exempt-from-sales-tax-in-your-state'
            t.text ' '
            t.b @onClickTaxExemptionCertificate, '.quiet', ->
              t.format 'submit-tax-exemption-certificate'
          if uploadCertSuccess
            t.p ->
              t.format 'thank-you-for-uploading-certificate-we-will-contact-if-theres-a-problem'
          if genCertFailure
            t.p '.u-form-error', ->
              t.format 'sorry-there-was-a-problem-please-get-in-touch'
    else
      t.div ->



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/tax-exemption-component.coffee